import { useContext } from 'react'
import { PaymentStepContext } from '../contexts/paymentStepContext'

const usePaymentStep = () => {
  return useContext(PaymentStepContext)
}

export default usePaymentStep
